import React, { useEffect } from 'react';
import { useSettingContext } from 'src/contexts/setting.context';
import { actionTypes } from 'src/ducks/setting.duck';
import { getSettingStatus } from 'src/selectors/setting.selector';
import ConfigurationSettingsListView from './configuration-settings-list.view';

const ConfigurationSettingsList: React.FC = () => {
  const { state, actions } = useSettingContext();

  useEffect(() => {
    actions.listGET();
  }, [actions]);

  return (
    <ConfigurationSettingsListView
      loading={getSettingStatus(state, actionTypes.SETTING_FETCH).fetching}
      data={state.list}
    />
  );
};

export default ConfigurationSettingsList;
